import { FC } from "react"
import { Card } from "../../../../../_webui/layout/components/Card"
import { Layout } from "../../../../../_webui/layout/components/Layout"
import { Upload } from "../../../../../_webui/layout/components/Upload"
import { File } from "../../../../../constant/File"
import { Translate } from "../../../../../constant/Translate"
import { SchedulesBatchDeleteModalButtonSubmit } from "../../components/batchDelete/ButtonSubmit"
import { SchedulesBatchDeleteModalConfirm } from "../../components/batchDelete/ModalConfirm"
import { SchedulesBatchDeleteModalTable } from "../../components/batchDelete/Table"
import { useSchedulesBatchDelete } from "./modules/useBatchDelete"

const { TEXT_T305 } = Translate
const { FILE_TYPE_ALLOW_UPLOAD_ACCEPT_ALL } = File

export const SchedulesBatchDelete: FC = () => {
  const {
    beforeUpload,
    breadcrumbItems,
    bulkDelete,
    bulkDeleteDataConfirm,
    bulkFileDelete,
    columnErrors,
    columns,
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isOpen,
    isOpenDeleted,
    isResetTable,
    isVisibleBtnCancel,
    isVisibleBtnDelete,
    onCancel,
    onCancelDeleted,
    onChange,
    onOpen,
    onOpenDeletedOrGoToHome,
    perItem,
  } = useSchedulesBatchDelete()

  return (
    <Layout
      isLoadingLayout={isLoadingLayout}
      breadcrumbItems={breadcrumbItems}
      title={TEXT_T305}
    >
      <Card heading={TEXT_T305} isLoading={isLoading}>
        <Upload
          accept={FILE_TYPE_ALLOW_UPLOAD_ACCEPT_ALL}
          customRequest={({ file }) =>
            beforeUpload(file, (upload: boolean) => {
              if (upload) {
                bulkFileDelete(file)
              }
            })
          }
          fileNameList={fileNameList}
        />
        <SchedulesBatchDeleteModalTable
          columnErrors={columnErrors}
          columns={columns}
          dataTemps={dataTemps}
          errorList={errorList}
          isResetTable={isResetTable}
          onChange={onChange}
          perItem={perItem}
          countRecord={countRecord}
        />
        <SchedulesBatchDeleteModalButtonSubmit
          isDisabledSubmit={isDisabledSubmit}
          isVisibleBtnCancel={isVisibleBtnCancel}
          isVisibleBtnDelete={isVisibleBtnDelete}
          onOpen={onOpen}
          onOpenDeletedOrGoToHome={onOpenDeletedOrGoToHome}
        />
        <SchedulesBatchDeleteModalConfirm
          bulkDelete={bulkDelete}
          bulkDeleteDataConfirm={bulkDeleteDataConfirm}
          isOpen={isOpen}
          isOpenDeleted={isOpenDeleted}
          onCancel={onCancel}
          onCancelDeleted={onCancelDeleted}
        />
      </Card>
    </Layout>
  )
}
